import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map(app_module => ({
        value: app_module.id,
        label: app_module.name,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/app_modules', { params });

      if (!data.success) {
        return [];
      }

      commit('setData', data.data);
      return data;
    },
    clear({ commit }) {
      commit('setData', []);
    }
  },
}
